var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkBroken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 46.5H30V34.5H42V31.5H27V46.5Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 16.5V1.5H18V13.5H6V16.5H21Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37895 40.7412L7.25905 40.6219C6.3843 39.7472 5.69041 38.7087 5.217 37.5658C4.74358 36.4229 4.49992 35.198 4.49992 33.9609C4.49992 32.7239 4.74358 31.4989 5.217 30.3561C5.69041 29.2132 6.3843 28.1747 7.25905 27.3L14.309 20.25H10.0662L5.13758 25.1784C2.80847 27.5076 1.5 30.6666 1.5 33.9605C1.5 37.2544 2.80847 40.4133 5.13758 42.7425L5.25739 42.8623C7.58838 45.188 10.7467 46.4942 14.0395 46.4942C17.3323 46.4942 20.4906 45.188 22.8216 42.8623L23.2501 42.4339V38.1912L20.7001 40.7412C18.9322 42.505 16.5368 43.4956 14.0395 43.4956C11.5422 43.4956 9.14686 42.505 7.37895 40.7412Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8625 5.25778L42.7427 5.13778C37.9002 0.295125 30.0208 0.295313 25.1784 5.13778L24.75 5.56641V9.80906L27.3 7.25906C29.0679 5.49516 31.4633 4.50455 33.9607 4.50455C36.4581 4.50455 38.8535 5.49516 40.6214 7.25906L40.7413 7.37888C41.6161 8.25359 42.3099 9.29204 42.7834 10.4349C43.2568 11.5778 43.5004 12.8028 43.5004 14.0398C43.5004 15.2769 43.2568 16.5018 42.7834 17.6447C42.3099 18.7876 41.6161 19.826 40.7413 20.7008L33.6913 27.7507H37.9338L42.8625 22.8218C45.1916 20.4927 46.5001 17.3337 46.5001 14.0398C46.5001 10.7459 45.1916 7.58694 42.8625 5.25778Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkBroken);
export default __webpack_public_path__ + "static/media/linkBroken.3e464125.svg";
export { ForwardRef as ReactComponent };